import * as React from 'react';
import * as styles from './MLSNPublicationBannerDesktop.css';
import { IMLSNPublicationBannerProps } from '../../types';
import logo from '../../images/logo.png';
import { Header4, Paragraph2 } from '@cian/ui-kit';

export const MLSNPublicationBannerDesktop = (props: IMLSNPublicationBannerProps) => {
  const { handleCloseClick } = props;

  return (
    <div className={styles['wrapper']}>
      <div className={styles['close']} onClick={handleCloseClick}>
        ×
      </div>

      <div className={styles['left']}>
        <div className={styles['title']}>
          <Header4>Циан + MLSN.ru: два сервиса по&nbsp;цене одного</Header4>
        </div>
        <Paragraph2 color="gray60_100">
          Все объявления с&nbsp;Циан автоматически публикуются на&nbsp;MLSN.ru, не&nbsp;теряя продвижения
        </Paragraph2>
      </div>

      <div>
        <img src={logo} width="200" height="36" />
      </div>
    </div>
  );
};
